/* globals Store */
import 'chart.js'
import {Line} from 'vue-chartjs'
import { mapState } from "vuex";

export default Line.extend({
  props: ['query'],
  data () {
    return {
      gradient: null,
      gradient2: null
    }
  },
  computed: {
    ...mapState("dashboard", {
      perdays: "perdays",
    }),
  },
  watch: {
    query() {
      const query = this.query;
      Store.dispatch("dashboard/getPerdaysLineChart", query);
    },
    perdays() {
//        let data1 = [];
      let data2 = [];
      let labels = [];
      Object.keys(this.perdays.perdays).forEach(item => {
//        data1.push(this.perdays.perdays[item].count * 10000);
        data2.push(this.perdays.perdays[item].sum);
        labels.push(this.perdays.perdays[item].day);
      });
//    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
      this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
//    this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)')
//    this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
//    this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
      this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
      this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
      this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');
      this.renderChart({
        labels: labels,
        datasets: [
//          {
//            label: 'Кол-во',
//            borderColor: '#FC2525',
//            pointBackgroundColor: 'white',
//            borderWidth: 1,
//            pointBorderColor: 'white',
//            backgroundColor: this.gradient,
//            data: data1
//          },
          {
            label: 'Оборот',
            borderColor: '#05CBE1',
            pointBackgroundColor: 'white',
            pointBorderColor: 'white',
            borderWidth: 1,
            backgroundColor: this.gradient2,
            data: data2
          }
        ]
      },
      {responsive: true, maintainAspectRatio: false})
    }
  },
  mounted () {
    const query = this.query;
    Store.dispatch("dashboard/getPerdaysLineChart", query);
  }
})


// WEBPACK FOOTER //
// ./src/components/chart/LineChart.js